module.exports = __webpack_public_path__ + "img/a1.4093c972.png";